const styles = theme => ({
    root: {
        backgroundColor: 'transparent',
        boxShadow: 'unset',
        fontSize: 22
    }
});

export default styles;